import { Component, OnInit, AfterViewInit, PLATFORM_ID, Inject, Input, OnDestroy } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-trust-pilot',
  templateUrl: './trust-pilot.component.html',
  styleUrls: ['./trust-pilot.component.scss']
})
export class TrustPilotComponent implements OnInit, AfterViewInit, OnDestroy {

  @Input() width;
  @Input() height;
  @Input() currentLang;

  constructor(
    @Inject(PLATFORM_ID) private platform: Object,
    public translate: TranslateService,
  ) { }

  ngOnInit() {
  }

  ngAfterViewInit() {
    if (isPlatformBrowser(this.platform)) {
      const trustBoxRef = document.getElementById('trustbox');
      Trustpilot.loadFromElement(trustBoxRef);
    }
  }

  ngOnDestroy() {
  }

}
